import DashboardLayout from '../Layouts/DashboardLayout';
import ConsultantsComp from './ConsultantsComp';

const ConsultantsContainer = () => {
  return (
    <DashboardLayout>
      <ConsultantsComp></ConsultantsComp>
    </DashboardLayout>
  );
};
export default ConsultantsContainer;
